/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignAnalysisPreflightResponseSchema } from '../campaign-schema';

export const getCampaignAnalysisPreflightPathSchema = z.object({
  campaignId: z.string(),
});

export const getCampaignAnalysisPreflightOperationResponseSchema =
  campaignAnalysisPreflightResponseSchema;

export type GetCampaignAnalysisPreflightInput = {
  path: z.input<typeof getCampaignAnalysisPreflightPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaignAnalysisPreflight({
  path,
  signal,
}: GetCampaignAnalysisPreflightInput): Promise<
  z.infer<typeof getCampaignAnalysisPreflightOperationResponseSchema>
> {
  const parsedPath = getCampaignAnalysisPreflightPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/analyses/preflight`,
    {
      signal,
    },
  );
  return getCampaignAnalysisPreflightOperationResponseSchema.parse(
    await response.json(),
  );
}
